import { useState, useEffect, useRef } from 'react';

import styles from './styles.module.scss';
import { ChevronDownIcon, TranslateLanguage } from 'assets/icons';
import en from 'assets/icons/flags/Britain.png';
import fa from 'assets/icons/flags/Iran.png';
import useTranslation from 'hooks/useTranslation';
import useClickOutside from 'hooks/useClickOutside';

const Languages = [
  {
    code: 'IR',
    flag: fa,
    content_fa: 'فارسی',
    content_en: 'Persian',
  },
  {
    code: 'EN',
    flag: en,
    content_fa: 'انگلیسی',
    content_en: 'English',
  },
];

function Menu() {
  const { getAppLocale, setAppLocale } = useTranslation();
  const [selected, setSelected] = useState(
    getAppLocale() === 'fa' ? Languages[0] : Languages[1]
  );
  const locale = getAppLocale();
  const menuRef = useRef(null);
  const [isComponentVisible, setIsComponentVisible] = useState(false);
  //   const { ref, isComponentVisible, setIsComponentVisible } =
  //     useClickOutside(false);

  const handleOpenMenu = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const handleCloseMenu = () => {
    setIsComponentVisible(false);
  };

  const handleSelectLang = (l) => () => {
    // push(pathname, pathname, { locale : l.code === 'IR' ? 'fa' : 'en' })
    // window.location.pathname = `${l.code === 'IR' ? '' : 'en'}/${pathname}`;
    const selectedLocale = l.code === 'IR' ? 'fa' : 'en';
    setSelected(l);
    setIsComponentVisible(false);
    setAppLocale(selectedLocale);
  };

  useClickOutside(menuRef, handleCloseMenu);

  useEffect(() => {
    // Add event listener
    window.addEventListener('resize', handleCloseMenu);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handleCloseMenu);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={menuRef} className={styles.menuContainer}>
      <div onClick={handleOpenMenu} className={styles.menu}>
        <img src={TranslateLanguage} alt='Translate Language' />

        <span className={styles.menu__flagCode}>
          {selected[locale === 'fa' ? 'content_fa' : 'content_en']}
        </span>
        {/* <SvgChervon data-open={isComponentVisible} /> */}

        <div data-open={isComponentVisible} className={styles.collapse__icon}>
          <ChevronDownIcon />
        </div>
      </div>

      <div className={styles.menu__menuItems} data-open={isComponentVisible}>
        {Languages.map((l) => {
          return (
            <div
              onClick={handleSelectLang(l)}
              className={styles.menu__menuItems__item}
              key={l.code}
            >
              <span>{locale === 'fa' ? l.content_fa : l.content_en}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Menu;
